angular.
module("dx.webapp.roles").
component("dxRoles", {
	templateUrl: "tmpl/roles/roles-component.html",
	controller: "DxRolesController",
	controllerAs: "vm",
	bindings: {
		node: "<",
	},
});
